<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isAddPopup ? '변수 추가' : '변수 수정'" width="600px" @close="close()">
    <div slot="content">
      <el-form :model="formData" :rules="rules" ref="variableForm" label-position="top">
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="variableId" label="아이디">
              <el-input v-model="formData.variableId" placeholder="입력해주세요." :disabled="!isAddPopup"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="variableName" label="이름">
              <el-input v-model="formData.variableName" placeholder="입력해주세요." :disabled="!editable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item prop="variableDesc" label="설명">
            <el-input v-model="formData.variableDesc" placeholder="입력해주세요." :disabled="!editable"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="variableValueType" label="데이터 타입">
              <el-select style="width: 100%;" v-model="formData.variableValueType" :disabled="!editable">
                <el-option value="STRING" label="STRING" />
                <el-option value="LIST" label="LIST"/>
                <el-option value="INTEGER" label="INTEGER"/>
                <el-option value="JSON" label="JSON"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderbyIndex" label="정렬 순서">
              <el-input-number controls-position="right" style="width: 100%;" v-model="formData.orderbyIndex" :disabled="!editable" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item prop="variableDefaultValue" label="기본 값">
            <el-input v-if="formData.variableValueType !== 'INTEGER'" v-model="formData.variableDefaultValue" placeholder="입력해주세요." :disabled="!editable"></el-input>
            <el-input-number v-if="formData.variableValueType === 'INTEGER'" v-model="formData.variableDefaultValue" placeholder="입력해주세요." :disabled="!editable"
            controls-position="right" style="width: 100%;" :step="1" step-strictly></el-input-number>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" v-if="editable">
      <el-button size="large" type="solid" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { isTrue, booleanDefine } from '@/utils/boolean';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';

export default {
  name: 'WVariableSettingPopup',
  props: {
    selectedVariable: Object,
  },
  data() {
    return {
      formData: {
        variableId: '',
        variableName: '',
        variableDesc: '',
        variableDefaultValue: '',
        variableValueType: '',
        orderbyIndex: 0,
        editableFlag: booleanDefine.TRUE_Y,
      },
      rules: {
        variableId: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
        variableName: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
        orderbyIndex: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
        variableValueType: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedVariable);
    },
    editable() {
      return isTrue(this.formData.editableFlag);
    },
  },
  watch: {
    'formData.variableValueType': {
      handler(newValue, oldValue) {
        if (oldValue === 'INTEGER' && newValue !== 'INTEGER') {
          this.formData.variableDefaultValue = '';
        } else if (oldValue !== 'INTEGER' && newValue === 'INTEGER') {
          this.formData.variableDefaultValue = '';
        }
      },
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      if (this.isAddPopup) {
        this.formData.variableValueType = 'STRING';
      }
      if (!isNil(this.selectedVariable)) {
        this.formData = cloneDeep(this.selectedVariable);
      }
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.variableForm.resetFields();
      this.formData = {
        variableId: '',
        variableName: '',
        variableDesc: '',
        variableDefaultValue: '',
        variableValueType: '',
        orderbyIndex: '',
        editableFlag: booleanDefine.TRUE_Y,
      };
    },
    /**
     * 저장 버튼 click
     * @author jeee12
     */
    onSaveButtonClick() {
      this.$refs.variableForm.validate().then((valid) => {
        if (valid) {
          amsSettingsApi.insertVariable({
            typeId: 'VARIABLE',
            ...this.formData,
          }).then((response) => {
            const target = '변수';
            const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
            if (response.data.success) {
              this.close();
              this.$emit('re-load');
            }
            this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
          });
        }
      }).catch(() => {});
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/VariableSetting/popup/VariableSettingPopup.vue